import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DashboardService } from "../../../services/dashboard.service";
import { ToastrService } from "ngx-toastr";
import * as Highcharts from "highcharts/highstock";
import HC_exporting from "highcharts/modules/exporting";

declare var require: any;
let Boost = require("highcharts/modules/boost");
let noData = require("highcharts/modules/no-data-to-display");
let More = require("highcharts/highcharts-more");

Boost(Highcharts);
noData(Highcharts);
More(Highcharts);

@Component({
  selector: "app-projects-graph",
  templateUrl: "./projects-graph.component.html",
  styleUrls: ["./projects-graph.component.scss"],
})
export class ProjectsGraphComponent implements OnInit {
  projectName: string = "";
  cala_id;

  array3A = [];
  array3D = [];
  array3G = [];
  array3H = [];

  constructor(
    private route: ActivatedRoute,
    private dashboardService: DashboardService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((param) => {
      this.projectName = param.get("name");
      this.cala_id = param.get("id");
    });

    this.dashboardService
      .getLastFourYearsData(this.cala_id)
      .subscribe((res) => {
        const [project] = (res || []).filter(
          (item) => item.project_name === this.projectName
        );

        if (!project) {
          this.toastr.error("Project graph data is not available.", "Error");
          return;
        }

        this.array3A = project["3A"].map((item) => {
          const [key, value] = Object.entries(item);
          return key;
        });
        this.array3D = project["3D"].map((item) => {
          const [key, value] = Object.entries(item);
          return key;
        });
        this.array3G = project["3G"].map((item) => {
          const [key, value] = Object.entries(item);
          return key;
        });
        this.array3H = project["3H"].map((item) => {
          const [key, value] = Object.entries(item);
          return key;
        });

        /////// Highchart Graph ////////////
        HC_exporting(Highcharts);
        this.graphOptions("container3A", "3(A)", this.array3A);
        this.graphOptions("container3D", "3(D)", this.array3D);
        this.graphOptions("container3G", "3(G)", this.array3G);
        this.graphOptions("container3H", "3(H)", this.array3H);
      }, () => {
        this.toastr.error("Failed to load project graph data. Please try again.", "Error");
      });
  }

  graphOptions(containerName: string, process: string, arr) {
    const chartFont = "Montserrat, 'Helvetica Neue', Arial, sans-serif";
    const options: any = {
      chart: {
        type: "column",
        style: {
          fontFamily: chartFont,
        },
      },
      title: {
        text: null,
      },
      // subtitle: {
      //   text: 'Source: <a href="http://en.wikipedia.org/wiki/List_of_cities_proper_by_population">Wikipedia</a>',
      // },
      xAxis: {
        type: "category",
        labels: {
          rotation: -45,
          style: {
            fontSize: "14px",
            fontWeight: "500",
            fontFamily: chartFont,
            color: "#475467",
          },
        },
      },
      yAxis: {
        min: 0,
        labels: {
          style: {
            fontSize: "14px",
            fontWeight: "500",
            fontFamily: chartFont,
            color: "#475467",
          },
        },
        title: {
          text: "Area (hectares)",
          style: {
            fontSize: "14px",
            fontWeight: "600",
            fontFamily: chartFont,
            color: "#344054",
          },
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        style: {
          fontFamily: chartFont,
          fontSize: "13px",
        },
        pointFormat: "Area acquired: <b>{point.y:.1f} hectares</b>",
      },
      series: [
        {
          name: "Area",
          data: [...arr].reverse(),
          dataLabels: {
            enabled: true,
            rotation: -90,
            color: "#1d2939",
            align: "center",
            formatter: function () {
              return this.y > 0 ? this.y.toFixed(1) : "";
            },
            style: {
              fontSize: "12px",
              fontWeight: "600",
              fontFamily: chartFont,
              textOutline: "none",
            },
          },
        },
      ],
    };
    return Highcharts.chart(containerName, options);
  }
}
